import { t } from 'i18next';

import { DataTableColumn } from 'components/dataTable';

import RoutePath from 'router/path';

import { CustodialWalletTransactionStatus, CustodialWalletTransactionType } from 'types/custodialWallet';
import { SortOrder } from 'types/sort';

import { makeLabels } from 'utils/i18n';

export const COLUMN_IDS = {
  TYPE: 'type',
  SOURCE_ID: 'sourceId',
  AMOUNT: 'amount',
  CREATED_AT: 'createdAt',
  STATUS: 'status',
  BALANCE: 'balance',
  ACTIONS: 'actions',
};

export const KEYS = {
  FILTER_KEY: 'refundAccounts',
  ROUTE_MATCH: `${RoutePath.Pwc.Accounts.ById}/:route`,
  DEFAULT_TABLE_SORTING: {
    FIELD: COLUMN_IDS.CREATED_AT,
    DIRECTION: SortOrder.desc,
  },
  FILTERS: {
    STATUSES: 'statuses',
  },
};

const NAMESPACE = 'page.merchant.accountSettings.refundAccounts';
export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['pageTitle', 'Refund Account'],
    TABLE_COLUMNS: {
      TYPE: ['tableColumns.type', 'Movements'],
      SOURCE_ID: ['tableColumns.sourceId', 'Source ID'],
      AMOUNT: ['tableColumns.settlementAmount', 'Settlement Amount'],
      CREATED_AT: ['tableColumns.creationDate', 'Creation Date'],
      STATUS: ['tableColumns.status', 'Status'],
      BALANCE: ['tableColumns.balance', 'Balance'],
    },
    TABLE_PLACEHOLDER: ['tablePlaceholder', 'No Movements Found on the Refund Account'],
    FETCH_TRANSACTIONS_ERROR: ['fetchTransactionsError', 'Unable to fetch transactions.'],
    TRANSACTION_TYPE_LABELS: {
      [CustodialWalletTransactionType.MerchantTopup]: ['transactionType.merchantTopup', 'Top-up'],
      [CustodialWalletTransactionType.Refund]: ['transactionType.refund', 'Refund'],
      [CustodialWalletTransactionType.Charge]: ['transactionType.charge', 'Charge'],
      [CustodialWalletTransactionType.Payout]: ['transactionType.payout', 'Payout'],
      [CustodialWalletTransactionType.TransferFromSettlementWallet]: [
        'transactionType.transferFromSettlementWallet',
        'Transfer from Settlement Wallet',
      ],
      [CustodialWalletTransactionType.TransferFromRefundWallet]: ['transactionType.refund', 'Refund'],
      [CustodialWalletTransactionType.TransferToRefundWallet]: ['transactionType.transferToRefundWallet', 'Transfer to Refund Wallet'],
    },
    FILTERS: {
      STATUS: {
        LABEL: ['filters.status.label', 'Status'],
      },
      TYPES: {
        LABEL: ['filters.types.label', 'Type'],
        [CustodialWalletTransactionType.MerchantTopup]: ['filters.types.topup', 'Top-up'],
        [CustodialWalletTransactionType.Refund]: ['filters.types.refund', 'Refund'],
      },
      DATE: {
        LABEL: ['filters.date.label', 'Date'],
      },
      SETTLEMENT_AMOUNT: {
        LABEL: ['filters.settlementAmount.label', 'Settlement Amount'],
      },
      STATUSES: {
        [CustodialWalletTransactionStatus.Failed]: ['filters.status.failed', 'Failed'],
        [CustodialWalletTransactionStatus.Completed]: ['filters.status.completed', 'Completed'],
        [CustodialWalletTransactionStatus.Submitted]: ['filters.status.submitted', 'Submitted'],
      },
    },
    REFUND_WALLET_BALANCE: ['refundWalletBalance', 'Refund Float Balance:'],
    TABLE_ACTIONS: {
      TITLE: ['tableActions.title', 'Actions'],
      COPY_ORDER_ID: ['tableActions.copyOrderId', 'Copy Order ID'],
      OPEN_TOPUP_DETAILS: ['tableActions.openTopupDetails', 'See Top Up Details'],
      OPEN_ORDER_DETAILS: ['tableActions.openRefundDetails', 'Open Refund Details'],
    },
    ACTIONS: {
      TOGGLE_TOPUP_MODAL: ['actions.toggleTopupModal', 'TOP UP'],
    },
  },
  NAMESPACE,
);

export const COLUMNS: DataTableColumn[] = [
  { id: COLUMN_IDS.TYPE, label: t(LABELS.TABLE_COLUMNS.TYPE) },
  { id: COLUMN_IDS.SOURCE_ID, label: t(LABELS.TABLE_COLUMNS.SOURCE_ID) },
  { id: COLUMN_IDS.AMOUNT, label: t(LABELS.TABLE_COLUMNS.AMOUNT), headCellProps: { align: 'right' } },
  { id: COLUMN_IDS.CREATED_AT, label: t(LABELS.TABLE_COLUMNS.CREATED_AT) },
  { id: COLUMN_IDS.STATUS, label: t(LABELS.TABLE_COLUMNS.STATUS) },
  { id: COLUMN_IDS.BALANCE, label: t(LABELS.TABLE_COLUMNS.BALANCE), headCellProps: { align: 'right' } },
  { id: COLUMN_IDS.ACTIONS, label: null },
];
